import React, {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import {KTSVG} from '../../../../../_metronic/helpers'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import {GetFilterContactSegment} from './SegmentSlice/SegmentSlice'
import moment from 'moment'
import {toast} from 'react-toastify'
import './SegmentMobileCard.scss'

interface SegmentMobileAction {
  key: string
  label: string
  icon?: string
  danger?: boolean
  onClick: () => void
}

interface SegmentMobileCardProps {
  segment: any
  count?: number | string
  onEdit: (segment: any) => void
  onDelete: (id: string) => void
  onExport: (id: string) => void
  onViewContacts: (segment: any) => void
}

export const SegmentMobileCard: React.FC<SegmentMobileCardProps> = ({
  segment,
  count,
  onEdit,
  onDelete,
  onExport,
  onViewContacts,
}) => {
  const [showActions, setShowActions] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleActionClick = () => {
    setShowActions(!showActions)
  }

  const actions: SegmentMobileAction[] = []

  if (AuthenticateUser('send-quick-sms')) {
    actions.push({
      key: 'send-message',
      label: 'Send Message',
      icon: 'bi bi-send',
      onClick: () => {
        navigate(`/new-message`, {
          state: {
            selectedType: 'segmentOrTags',
            data: `segment_${segment._id}`,
          },
        })
        setShowActions(false)
      },
    })
  }

  if (AuthenticateUser('segments-list')) {
    actions.push({
      key: 'view-contacts',
      label: 'View Contacts',
      icon: 'bi bi-eye',
      onClick: () => {
        onViewContacts(segment)
        setShowActions(false)
      },
    })
  }

  if (AuthenticateUser('export-segment-based-contacts')) {
    actions.push({
      key: 'export',
      label: 'Export as CSV',
      icon: 'bi bi-download',
      onClick: () => {
        onExport(segment._id)
        setShowActions(false)
      },
    })
  }

  actions.push({
    key: 'copy-id',
    label: 'Copy ID',
    icon: 'bi bi-clipboard',
    onClick: () => {
      navigator.clipboard.writeText(segment._id)
      toast.success('Successfully copied segment id')
      setShowActions(false)
    },
  })

  if (AuthenticateUser('edit-segment')) {
    actions.push({
      key: 'edit',
      label: 'Edit',
      icon: 'bi bi-pencil',
      onClick: () => {
        onEdit(segment)
        setShowActions(false)
      },
    })
  }

  if (AuthenticateUser('delete-segment') && !segment?.isInBuild) {
    actions.push({
      key: 'delete',
      label: 'Delete Segment',
      icon: 'bi bi-trash',
      danger: true,
      onClick: () => {
        onDelete(segment._id)
        setShowActions(false)
      },
    })
  }

  return (
    <div className='segment-mobile-card'>
      {/* Header with name and actions */}
      <div className='card-header-section'>
        <div className='segment-info-section'>
          <h5
            className='segment-name cursor-pointer'
            onClick={() => {
              navigate('/segmentfilterContact', {state: segment})
              dispatch(GetFilterContactSegment({id: segment._id}))
            }}
          >
            {segment?.name}
          </h5>
        </div>
        <button
          className='btn btn-action-mobile'
          onClick={handleActionClick}
          aria-label='Actions menu'
          aria-expanded={showActions}
        >
          <i className='bi bi-three-dots-vertical'></i>
        </button>
      </div>

      {/* Actions dropdown */}
      {showActions && (
        <div className='actions-dropdown'>
          {actions.map((action) => (
            <button
              key={action.key}
              className={`action-item ${action.danger ? 'text-danger' : ''}`}
              onClick={action.onClick}
            >
              {action.icon && <i className={`${action.icon} me-2`}></i>}
              {action.label}
            </button>
          ))}
        </div>
      )}

      {/* Segment details grid */}
      <div className='card-details-grid'>
        <div className='detail-item full-width'>
          <span className='detail-label'>
            <i className='bi bi-people me-1'></i>
            Total Contacts
          </span>
          <span className='detail-value'>
            {count !== undefined && count !== null ? count : '..counting'}
          </span>
        </div>

        {/* Date Created */}
        {segment?.createdAt && (
          <div className='detail-item'>
            <span className='detail-label'>
              <i className='fas fa-calendar-plus me-1'></i>
              Date Created
            </span>
            <span className='detail-value'>{moment(segment.createdAt).format('DD/MM/YYYY')}</span>
          </div>
        )}
        {/* Last Update */}
        {segment?.createdAt && (
          <div className='detail-item'>
            <span className='detail-label'>
              <i className='fas fa-calendar-check me-1'></i>
              Last Update
            </span>
            <span className='detail-value'>{moment(segment.createdAt).format('DD/MM/YYYY')}</span>
          </div>
        )}
      </div>

      {/* Action buttons */}
      <div className='card-actions'>
        {AuthenticateUser('send-quick-sms') && (
          <button
            className='btn btn-light-primary btn-sm'
            onClick={() => {
              navigate(`/new-message`, {
                state: {
                  selectedType: 'segmentOrTags',
                  data: `segment_${segment._id}`,
                },
              })
            }}
          >
            <KTSVG path='/media/icons/duotune/art/rocket.svg' className='svg-icon-3' />
            Send
          </button>
        )}
        {AuthenticateUser('edit-segment') && (
          <button
            className='btn btn-light btn-sm'
            onClick={() => onEdit(segment)}
          >
            <i className='bi bi-pencil me-2'></i>
            Edit
          </button>
        )}
        <button
          className='btn btn-light btn-sm'
          onClick={() => {
            navigate('/segmentfilterContact', {state: segment})
            dispatch(GetFilterContactSegment({id: segment._id}))
          }}
        >
          <i className='bi bi-eye me-2'></i>
          View
        </button>
      </div>
    </div>
  )
}

